/* eslint-disable import/no-unresolved */
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty, kebabCase } from 'lodash';
import { motion } from 'framer-motion';
import Button from '../layouts/Button';
import Link from '../layouts/Link';

export default function HomeDesktopActivitiesCards({ data }) {
  const breakpoints = {
    640: {
      slidesPerView: 1.5,
      slidesPerGroup: 1,
    },
    768: {
      slidesPerView: 2,
      slidesPerGroup: 1,
      pagination: false,
      centeredSlides: false,
    },
    992: {
      slidesPerView: 2.2,
      slidesPerGroup: 1,
      pagination: false,
      centeredSlides: false,
    },
    1100: {
      slidesPerView: 4,
      slidesPerGroup: 1,
      pagination: false,
      spaceBetween: 0,
      centeredSlides: false,
    },
  };
  return (
    <Swiper slidesPerView={1} breakpoints={breakpoints} className="mySwiper md:block hidden">
      {isEmpty(data) ||
        data.map((item, index) => (
          <SwiperSlide
            className="relative !h-[1030px] before:!inline before:content-['']
        before:absolute before:top-0 before:w-full before:h-full before:bg-black
        before:bg-opacity-50 before:z-5 group overflow-hidden"
            key={index}
          >
            {item.content.image && (
              <LazyLoadImage
                src={item.content.image.url}
                alt={item.content.title}
                className="w-full h-full object-cover transition-all duration-400 ease-in-out
                group-hover:scale-110"
              />
            )}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.3 * index }}
              viewport={{ once: true }}
              className="absolute top-0 pt-[158px] pb-[102px] flex flex-col gap-y-[51px] w-full
              h-full items-center z-10"
            >
              <div className="min-h-[480px] flex flex-col gap-y-[37px] text-center">
                {isEmpty(item.content.title) || (
                  <h3
                    className="font-roboto-condensed-bold text-white text-[32px] leading-[38px]
                uppercase"
                  >
                    {item.content.title}
                  </h3>
                )}
                {isEmpty(item.content.links) || (
                  <div className="flex flex-col gap-y-[10px] items-center justify-center h-full">
                    {item.content.links.map((linkItem, inde) => (
                      <Link
                        to={linkItem.url}
                        key={inde}
                        aria-label={linkItem.name}
                        className={`font-roboto-regular text-lg text-white relative
                        after:absolute after:-bottom-1
                        after:left-0 after:h-[2px] after:w-0 hover:after:w-full
                        after:transition-all after:duration-400 after:ease-in-out
                        after:bg-white w-fit ${
                          linkItem.url === '#0' ? '' : `after:content[''] after:block `
                        }`}
                      >
                        {linkItem.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
              {isEmpty(item.content.buttons) || (
                <div className="flex flex-col gap-y-4">
                  {item.content.buttons.map((buttonItem, ind) => (
                    <div className="w-[198px]" key={ind}>
                      <Button
                        ariaLabel={buttonItem.name}
                        url={buttonItem.url}
                        label={buttonItem.name}
                        tagName={`${kebabCase(item.content.title)}-${kebabCase(buttonItem.name)}`}
                        variant={ind === 0 ? 'primaryRed' : 'primaryWhite'}
                      />
                    </div>
                  ))}
                </div>
              )}
            </motion.div>
          </SwiperSlide>
        ))}
    </Swiper>
  );
}
